import type { FormLocale } from '@jlg-website/shared';
import { textFor } from './copy';

type NotesFieldProps = {
  /** Own id per flow: both confirmation screens carry this field, never at the same time. */
  id: string;
  notes: string;
  locale: FormLocale;
  onChange: (notes: string) => void;
};

/** "Anything we should know?" — the optional note both confirmation screens collect. */
export function NotesField({ id, notes, locale, onChange }: NotesFieldProps) {
  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm font-semibold text-brand-text-button" htmlFor={id}>
        {textFor(locale, 'notesLabel')}{' '}
        <span className="font-normal text-gray-light">{textFor(locale, 'optional')}</span>
      </label>

      <textarea
        id={id}
        value={notes}
        onChange={(event) => onChange(event.target.value)}
        placeholder={textFor(locale, 'notesPlaceholder')}
        rows={4}
        className="w-full resize-y rounded-lg border border-brand-muted-light bg-white p-3 text-sm text-brand-text-button placeholder:text-gray-light"
      />
    </div>
  );
}
